import React, { useEffect, useRef, useState } from "react";


import fallback_img from "../../../img/fallback_img.jpg"
import loading_img from "../../../img/loadingImg.jpg"
import { SelectionProvider } from "../Utils/ElementRenderer/SelectionContext";
import { HoverProvider } from "../Utils/ElementRenderer/HoverContext";
import { DragProvider } from "../Utils/ElementRenderer/DragContext";
import { PickerProvider } from "../Utils/ElementRenderer/Elements/PickerContext";
import { PageRenderer } from "../Utils/ElementRenderer/Renderer";
import { samplePage, ThemeRegistry } from "../Utils/ThemeRegistry/ThemeRegistry";
import { resolveAllStyles } from "../Utils/ThemeResolver";

const ListUI = ({ currentIndex,CurrentObject ,setCurrentObject, 
    
}) => {
  const [page , setPage]= useState(resolveAllStyles(samplePage, ThemeRegistry.theme1));
  
const ImageFallFB = ({ src,width, borderRadius,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true)
             },[ currentIndex]
         )
  return (
    <div >
      {!isLoaded && !hasError && (
        <div
         style={
             { width: `${width}%`,
              borderRadius:`${borderRadius?.value}${borderRadius?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      height: "100%",
      objectFit: "cover",  }}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
              // width:iWidth,
              borderRadius:`${borderRadius?.value}${borderRadius?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      height: "100%",
      objectFit: "cover",  }}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {borderRadius:`${borderRadius?.value}${borderRadius?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      height: `${width}%`,
      objectFit: "cover",  }}
      />
    </div>
  );
};


const ImageFallFBLoading = ({ src,width, borderRadius,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
  return (
    <div >
      {(
        <div
         style={
             { 
              borderRadius:`${borderRadius?.value}${borderRadius?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,background:"#444",
      width: `100%`,
      height: "100%",
      objectFit: "cover",  }}
        >
         
        </div>
      )}
      
    </div>
  );
};


  const [itemWidth, setitemWidth] = useState("100%");
                   const columns = CurrentObject?.columns 
                   ;// black / white
                     const scrollItemsLocal= CurrentObject?.scrollItems ;
    const titleFontSizeLocal= CurrentObject?.titleFontSize;
const subtitleFontSizeLocal=  CurrentObject?.subTitleFontSize;
    const titleFontColorLocal=  CurrentObject?.titleFontColor ;
const subTitleFontColorLocal=  CurrentObject?.subTitleFontColor ;
 const titleFontWeightLocal=  CurrentObject?.titleFontWeight ;
const subtitleFontWeightLocal=  CurrentObject?.subTitleFontWeight ;
 const showTitleLocal=  CurrentObject?.showTitle ;
const showSubTitleLocal=  CurrentObject?.showSubTitle;

const aspectRatioLocal=  CurrentObject?.aspectRatio ;
const imarginLeftLocal=  CurrentObject?.imarginLeft ;
const imarginTopLocal=  CurrentObject?.imarginTop ;
const marginLeftLocal=  CurrentObject?.marginLeft;
const marginTopLocal=  CurrentObject?.marginTop ;
const marginBottomLocal=  CurrentObject?.marginBottom ;
const borderRadiusLocal=  CurrentObject?.borderRadius ;
const fontFamilyLocal=  CurrentObject?.fontFamily ;
const textAlignmentLocal=  CurrentObject?.textAlignment ;
const iWidthLocal=  CurrentObject?.iWidth ;
const textPositionLocal=  CurrentObject?.textPosition;
const applyOverlayLocal=  CurrentObject?.applyOverlay ;
const overlayTitleFontColorLocal=  CurrentObject?.overlayTitleFontColor ;
const overlayBGLocal=  CurrentObject?.overlayBG ;
const absoluteHorizontalLocal=  CurrentObject?.absoluteHorizontal ;
const absoluteHorizontalMarginLocal=  CurrentObject?.absoluteHorizontalMargin ;
const absoluteVerticalLocal=  CurrentObject?.absoluteVertical ;
const absoluteVerticalMarginLocal=  CurrentObject?.absoluteVerticalMargin ;
// const overlayLocal= overlay[dynamicId] ;
  const containerRef = useRef(null);
  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
const [elementOpacity, setElementOpacity] = useState(0);
const [loadingCards, setLoadingCards] = useState(0);
//text Position
// image overlay
const [imageOverlayColor, setImageOverlayColor] = useState("rgba(144, 202, 249,0.15)");
// On Image Text 
const [overlayTextAlign, setOverlayTextAlign] = useState("bottom");
const [imageOverlayTextColor, setImageOverlayTextColor] = useState("#fff");
const [overlayTextMargin, setoverlayTextMargin] = useState("2%");

  const handleMouseDown = (e) => {
    setIsDown(true);
    setStartX(e.pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
  };

  const handleMouseLeave = () => setIsDown(false);
  const handleMouseUp = () => setIsDown(false);

  const handleMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 1.5; // scroll speed
    containerRef.current.scrollLeft = scrollLeft - walk;
  };



 

 const rows = [];
  for (let i = 0; i < CurrentObject?.images?.length; i += columns) {
    rows.push(CurrentObject?.images?.slice(i, i + columns));
  }

useEffect(()=>{
   setElementOpacity(0.3);setTimeout(()=>{  setElementOpacity(1);},300)
   setLoadingCards(true);setTimeout(()=>{  setLoadingCards(false);},0)
  const div = document.getElementById('ListDivId');
  if (div) {
  const screenWidth = div.getBoundingClientRect().width;

let itemWidth = screenWidth / columns;
setitemWidth(itemWidth);

}
},[itemWidth,columns])

  return (<div id="ListDivId" style={{position:"relative",opacity:elementOpacity,marginTop:`${marginTopLocal}px`,marginBottom:`${marginBottomLocal}px`}} onClick={()=>{ setCurrentObject() ;}}>
                          
                         
                            {scrollItemsLocal=="Scroll"? <div
      ref={containerRef}
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeave}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
      style={{marginLeft:marginLeftLocal,marginRight:marginLeftLocal,
        display: "flex",gap:5,
        overflowX: "scroll",overflowY: "hidden",
        scrollBehavior: "smooth",
        WebkitOverflowScrolling: "touch",
        
        cursor: isDown ? "grabbing" : "grab",
        scrollbarWidth: "none", // Firefox
        msOverflowStyle: "none",  userSelect: "none",           // Disables text selection
  WebkitUserSelect: "none",     // Safari
  MozUserSelect: "none",        // Firefox
  msUserSelect: "none", // IE/Edge
  msOverflowStyle: "none"
      }}
    >
      {/* Hide scrollbar in Webkit */}
        
  {CurrentObject?.images?.map((item) => (
     <div key={item.id} style={ { flex: 1 , position: "relative",
  }}>{<div>
    
     {textPositionLocal=="above"?<div style={{marginBottom:"4px"}}>
             {!loadingCards&&showTitleLocal?<div style={{position: "relative",}}><p  className="ButtonWithEllipsis" style={{
             width: `${itemWidth-19}px`, fontSize:`${titleFontSizeLocal}px`,fontWeight:titleFontWeightLocal,textAlign: textAlignmentLocal ,
             fontFamily:fontFamilyLocal?.fontFamily,margin:"0px",marginBottom:"4px",padding:"0px",color:titleFontColorLocal?.color
      }}>{item.title}</p></div>:""} 
       {!loadingCards&&showSubTitleLocal?<div  className="ButtonWithEllipsis" style={{
             width: `${itemWidth-19}px`, fontSize:`${subtitleFontSizeLocal}px`,fontWeight:subtitleFontWeightLocal,textAlign: textAlignmentLocal ,
             fontFamily:fontFamilyLocal?.fontFamily,margin:"0px",marginBottom:"4px",padding:"0px",color:subTitleFontColorLocal?.color
      }}>{item.subtitle}</div>:""}</div>:""}
    <div style={ {
    width: `${itemWidth -imarginLeftLocal}px`,
    position: "relative",
  
     // or any aspect ratio
    overflow: "hidden",aspectRatio: aspectRatioLocal,
  }}>
            {  <ImageFallFB src={item.image} width={iWidthLocal} borderRadius={borderRadiusLocal} />}
           
             <div style={applyOverlayLocal?{ borderRadius:`${borderRadiusLocal?.value}${borderRadiusLocal?.resolution}`,
                position: "absolute",background:overlayBGLocal?.color,
      top: 0,
      left: 0,
      width: `${iWidthLocal}%`,
      height: `${iWidthLocal}%`
      ,overflow:"hidden",
      objectFit: "cover", }:{ borderRadius:`${borderRadiusLocal?.value}${borderRadiusLocal?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${iWidthLocal}%`,
      height: `${iWidthLocal}%`
      ,overflow:"hidden",
      objectFit: "cover", }}>
        {textPositionLocal=="onImage"? <div style={{position:"absolute",top:absoluteVerticalLocal=="top"?
       `${absoluteVerticalMarginLocal}%`:"",bottom:absoluteVerticalLocal=="bottom"?
        `${absoluteVerticalMarginLocal}%`:"",left:absoluteHorizontalLocal=="left"?
       `${absoluteHorizontalMarginLocal}%`:"",right:absoluteHorizontalLocal=="right"?
        `${absoluteHorizontalMarginLocal}%`:"",padding:"3px"} }
      >
             {!loadingCards&&showTitleLocal?<div style={{position: "relative",}}><p  className="ButtonWithEllipsis" style={{
             width: `${itemWidth-24}px`, fontSize:`${titleFontSizeLocal}px`,fontWeight:titleFontWeightLocal,textAlign: textAlignmentLocal ,
             fontFamily:fontFamilyLocal?.fontFamily,margin:"0px",marginTop:"4px",padding:"0px",color:overlayTitleFontColorLocal?.color
      }}>{item.title}</p></div>:""} 
       {!loadingCards&&showSubTitleLocal?<div  className="ButtonWithEllipsis" style={{
             width: `${itemWidth-24}px`, fontSize:`${subtitleFontSizeLocal}px`,fontWeight:subtitleFontWeightLocal,textAlign: textAlignmentLocal ,
             fontFamily:fontFamilyLocal?.fontFamily,margin:"0px",marginTop:"4px",padding:"0px",color:overlayTitleFontColorLocal?.color
      }}>{item.subtitle}</div>:""}
            </div>:""}  
            
             </div> 
            
            </div>
               {textPositionLocal=="below"?<div>
             {!loadingCards&&showTitleLocal?<div style={{position: "relative",}}><p  className="ButtonWithEllipsis" style={{
             width: `${itemWidth-19}px`, fontSize:`${titleFontSizeLocal}px`,fontWeight:titleFontWeightLocal,textAlign: textAlignmentLocal ,
             fontFamily:fontFamilyLocal?.fontFamily,margin:"0px",marginTop:"4px",padding:"0px",color:titleFontColorLocal?.color
      }}>{item.title}</p></div>:""} 
       {!loadingCards&&showSubTitleLocal?<div  className="ButtonWithEllipsis" style={{
             width: `${itemWidth-19}px`, fontSize:`${subtitleFontSizeLocal}px`,fontWeight:subtitleFontWeightLocal,textAlign: textAlignmentLocal ,
             fontFamily:fontFamilyLocal?.fontFamily,margin:"0px",marginTop:"4px",padding:"0px",color:subTitleFontColorLocal?.color
      }}>{item.subtitle}</div>:""}</div>:""}
            
              
            </div>}</div>
  ))}
</div>


: <div >
               { CurrentObject?.images?.length===0?  <div  style={{
            display:"flex",flexDirection: 'row',
    justifyContent: 'center',padding:"5px",
    marginBottom: 10}}>
           <img
        src={fallback_img }
        alt=""
       
        style={{
          borderRadius: "10px",
        
          width: "50%",
          marginTop: "10px",border:"3px solid rgba(144, 202, 249,1)",
        //   display: isLoaded && !hasError ? "block" : "none",
        }}
      /></div>:""}             
    <div>
      {rows.map((row, rowIndex) => (
        <div key={rowIndex} style={{  padding:"10px",
            display:"flex",
    justifyContent: 'center',gap:5
   }}>


   {row.map((item) => (item?.hideImage||
            <div onClick={()=>{}} key={item.id} style={ {  position: "relative",  flex: 1 ,
 
  }}>   {textPositionLocal=="above"?<div style={{marginBottom:"4px"}}>
             {!loadingCards&&showTitleLocal?<div style={{position: "relative",}}><p  className="ButtonWithEllipsis" style={{
             width: `${itemWidth-10}px`, fontSize:`${titleFontSizeLocal}px`,fontWeight:titleFontWeightLocal,textAlign: textAlignmentLocal ,
             fontFamily:fontFamilyLocal?.fontFamily,margin:"0px",marginBottom:"4px",padding:"0px",color:titleFontColorLocal?.color
      }}>{item.title}</p></div>:""} 
       {!loadingCards&&showSubTitleLocal?<div  className="ButtonWithEllipsis" style={{
             width: `${itemWidth-10}px`, fontSize:`${subtitleFontSizeLocal}px`,fontWeight:subtitleFontWeightLocal,textAlign: textAlignmentLocal ,
             fontFamily:fontFamilyLocal?.fontFamily,margin:"0px",marginBottom:"4px",padding:"0px",color:subTitleFontColorLocal?.color
      }}>{item.subtitle}</div>:""}</div>:""}
      
      <div style={ {
    // width: `${itemWidth}px`,
    position: "relative",
    width: `${iWidthLocal}%`,
     // or any aspect ratio
    overflow: "hidden",aspectRatio: aspectRatioLocal,
  }}>
            {  <ImageFallFB src={item.image} width={iWidthLocal} paddingLeft={imarginLeftLocal}
            paddingRight={imarginLeftLocal} borderRadius={borderRadiusLocal} />}
           <div style={applyOverlayLocal?{ borderRadius:`${borderRadiusLocal?.value}${borderRadiusLocal?.resolution}`,
                position: "absolute",background:overlayBGLocal?.color,
      top: 0,
      left: 0,
      width: `${iWidthLocal}%`,
      height: `${iWidthLocal}%`,overflow:"hidden",
      objectFit: "cover", }:{ borderRadius:`${borderRadiusLocal?.value}${borderRadiusLocal?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${iWidthLocal}%`,
      height: `${iWidthLocal}%`,overflow:"hidden",
      objectFit: "cover", }}>
        {textPositionLocal=="onImage"? <div style={{position:"absolute",top:absoluteVerticalLocal=="top"?
       `${absoluteVerticalMarginLocal}%`:"",bottom:absoluteVerticalLocal=="bottom"?
        `${absoluteVerticalMarginLocal}%`:"",left:absoluteHorizontalLocal=="left"?
       `${absoluteHorizontalMarginLocal}%`:"",right:absoluteHorizontalLocal=="right"?
        `${absoluteHorizontalMarginLocal}%`:"",padding:"3px"} }> 
             {!loadingCards&&showTitleLocal?<div style={{position: "relative",}}><p  className="ButtonWithEllipsis" style={{
             width: `${columns=="1"?itemWidth-25:columns=="2"?itemWidth-18:columns=="3"?itemWidth-15:itemWidth-13}px`, fontSize:`${titleFontSizeLocal}px`,fontWeight:titleFontWeightLocal,textAlign: textAlignmentLocal ,
             fontFamily:fontFamilyLocal?.fontFamily,margin:"0px",marginTop:"4px",padding:"0px",color:overlayTitleFontColorLocal?.color
      }}>{item.title}</p></div>:""} 
       {!loadingCards&&showSubTitleLocal?<div  className="ButtonWithEllipsis" style={{
             width: `${columns=="1"?itemWidth-25:columns=="2"?itemWidth-18:columns=="3"?itemWidth-15:itemWidth-13}px`, fontSize:`${subtitleFontSizeLocal}px`,fontWeight:subtitleFontWeightLocal,textAlign: textAlignmentLocal ,
             fontFamily:fontFamilyLocal?.fontFamily,margin:"0px",marginTop:"4px",padding:"0px",color:overlayTitleFontColorLocal?.color
      }}>{item.subtitle}</div>:""}
            </div>:""}  
            
             </div> 
             
             </div>
             {textPositionLocal=="below"?<div>
             {!loadingCards&&showTitleLocal?<div style={{position: "relative",}}><p  className="ButtonWithEllipsis" style={{
             width: `${itemWidth-10}px`, fontSize:`${titleFontSizeLocal}px`,fontWeight:titleFontWeightLocal,textAlign: textAlignmentLocal ,
             fontFamily:fontFamilyLocal?.fontFamily,margin:"0px",marginTop:"4px",padding:"0px",color:titleFontColorLocal?.color
      }}>{item.title}</p></div>:""} 
       {!loadingCards&&showSubTitleLocal?<div  className="ButtonWithEllipsis" style={{
             width: `${itemWidth-10}px`, fontSize:`${subtitleFontSizeLocal}px`,fontWeight:subtitleFontWeightLocal,textAlign: textAlignmentLocal ,
             fontFamily:fontFamilyLocal?.fontFamily,margin:"0px",marginTop:"4px",padding:"0px",color:subTitleFontColorLocal?.color
      }}>{item.subtitle}</div>:""}</div>:""}
            </div>
          ))}
         
          {Array.from({ length: columns - row?.length }).map((_, idx) => (
            <div key={`empty-${idx}`} style={ { flex: 1, opacity: 0 }} />
          ))}
        </div>
      ))}
    </div>
                                       </div>
                                      
                                       }
                           <SelectionProvider>
                            <HoverProvider>
                               <DragProvider>
                                  <PickerProvider>
                              <PageRenderer page={page} setPage={setPage} />
                              </PickerProvider>
                              </DragProvider>
                            </HoverProvider>
                          </SelectionProvider>   </div> );
};


export default ListUI;
